// extracted by mini-css-extract-plugin
module.exports = {"state":"styles_state__27OSn","illustration":"styles_illustration__39QPj"};